import config from '../config'
/* eslint-disable */
export default class RegionFinder {

    constructor() {

        this.serverHost = config.serverURL;
        this.serverList;
        this.serverPingList;

        this.getFastest = this.getFastest.bind(this);

    }

    async _fetchServerList() {

        const response = await fetch(`${this.serverHost}/region/listPing`);

        return await response.json();

    }

    async _getRelevantServers(limit = 8){

        const results = {};

        for (let [key, serverIP] of Object.entries(this.serverList)) {

            await (async () => {

                const startTime = Date.now();

                try {
                    // try{ await fetch('https://'+serverIP+'/') }catch(ex){}
                    await fetch(`https://${serverIP.split(':')[0]}:8080/ping`);
                } catch (ex) {
                }
                    results[key] = results[key] || [];

                    results[key].push(Date.now() - startTime);



            })();

        }


        return Object.entries(results).sort((x, y) => x[1] - y[1]).slice(0, 8).map(entry => entry[0]);

    }

    _getFilterHighestTimings(results, limit = 4){

        const length = Object.entries(results).length;

        return Object.entries(results).sort((x, y) => x[1] - y[1]).slice(0, Math.ceil(((length - 1) / 2))).map(entry => entry[0]);

    }

    async getFastest(ignoreCache, selectedServer) {

        if (!this.result || ignoreCache) {
            const result = await this._fetchServerList();
            this.serverList = result.proxy;
            this.serverPingList = result.ping;
            const results = {};

            if(selectedServer === 'AutoDetect'){

                debugger;
                let relevantServers = await this._getRelevantServers(this.serverList);

                let serverListEntries = Object.entries(this.serverPingList);

                await (async () => {

                    const resultsFilter = {};
                    for (let [key, serverIP] of serverListEntries) {

                        if(relevantServers.indexOf(key) === -1){

                            continue;

                        }
                        const startTime = Date.now();

                        try{ await fetch('https://'+serverIP+'/') }catch(ex){ }

                        resultsFilter[key] = results[key] || [];

                        resultsFilter[key].push(Date.now() - startTime);

                    }

                    relevantServers = this._getFilterHighestTimings(resultsFilter);

                })();



                for (let i = 0; i < 5; i++) {

                    //-------------

                    await (async () => {

                        const promises = [];

                        serverListEntries = serverListEntries.reverse();

                        for (let [key, serverIP] of serverListEntries) {

                            if(relevantServers.indexOf(key) === -1){

                                continue;

                            }
                            const startTime = Date.now();

                            promises.push((async ()=> {

                                try{ await fetch('https://'+serverIP+'/') }catch(ex){ }

                            })().then(()=>{

                                results[key] = results[key] || [];

                                results[key].push(Date.now() - startTime);

                            }))
                        }

                        await Promise.all(promises);

                    })();




                    if(i === 0){

                        relevantServers = this._getFilterHighestTimings(results);

                    }



                }

                let fastest;
                let fastestTimming;
                for (let [key, timming] of Object.entries(results)) {

                    const avgTime = timming.reduce((a, v, i) => (a * i + v) / (i + 1));

                    if (!fastestTimming || fastestTimming > avgTime) {

                        fastest = key;
                        fastestTimming = avgTime;

                    }

                }

                this.result = {ip: this.serverList[fastest], name: fastest};
            }else{
                this.result = {ip: this.serverList[selectedServer], name: selectedServer};
            }


            // this.result = {ip: "35.198.55.213:3128", name: 'Brazil'};

        }

        return this.result;

    }

}
